<!--
 * @Author: yaoyuting
 * @Date: 2021-04-11 18:24:56
 * @LastEditors: yaoyuting
 * @LastEditTime: 2021-05-19 19:49:54
 * @Descripttion:
-->
<template>
    <div class="Blog">
        <div class="title">
            <div class="BigTitle">{{ $t("Wave.title") }}</div>
            <div class="SubTitle">{{ $t("Wave.what") }}</div>
            <div class="detail">{{ $t("Wave.detail") }}</div>
        </div>
        <div class="box-card">
            <div class="item">
                <img class="img1" src="../../../assets/m/intro/goal.png"/>
                <div class="introT">{{ $t("Wave.goal") }}</div>
                <div class="introD">{{ $t("Wave.goalDetail") }}</div>
            </div>
            <div class="item">
                <img class="img2" src="../../../assets/m/intro/algorithm.png"/>
                <div class="introT">{{ $t("Wave.alg") }}</div>
                <div class="introD">{{ $t("Wave.algDetail") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  mounted() {
   // this.init();
  },
  destroyed() {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
    .Blog {
        text-align: center;
        margin-bottom: 157px;
        width: 100%;
        color: #000000;
        .title {
            text-align: center;
            /*height: 761px;*/
            background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
            100%;
            .BigTitle {
                padding-top: 230px;
                width: 648px;
                font-size: 64px;
                font-weight: 900;
                color: #000000;
                font-family: Poppins-Black, Poppins;
                line-height: 83px;
                margin: 0 auto;
                padding-bottom: 20px;
            }
            .SubTitle {
                font-size: 30px;
                font-weight: 500;
                font-family: Poppins-Medium, Poppins;
                color: #000000;
                line-height: 35px;
                padding-bottom: 20px;
            }
            .detail {
                width: 645px;
                font-size: 26px;
                font-weight: 500;
                font-family: Poppins-Medium, Poppins;
                color: #61666B;
                line-height: 43px;
                margin: 0 auto;
            }
        }
        .box-card {
            margin-top: 120px;
            text-align: center;
            margin-bottom: 253px;
            .item {
                cursor: pointer;
                width: 650px;
                margin: 0 auto;
                /*img {*/
                /*    width: 111px;*/
                /*    height: 105px;*/
                /*}*/
                .img1{
                    width: 120px;
                    height: 122px;
                }
                .img2{
                    width: 130px;
                    height: 100px;
                }
                .introT {
                    font-size: 32px;
                    font-weight: 600;
                    color: #1A1A2C;
                    font-family: Poppins-SemiBold, Poppins;
                    line-height: 54px;
                    margin-top: 30px;
                    margin-bottom: 30px;
                }
                .introD {
                    width: 650px;
                    font-size: 28px;
                    font-weight: 500;
                    color: #61666B;
                    font-family: PingFang SC-Medium, PingFang SC;
                    line-height: 46px;
                    margin-bottom: 120px;
                }
            }
         }
    }
</style>
